import useMediaQuery from '@mui/material/useMediaQuery';


interface data {
  type: string;
}

function Divider(props: data) {
  const matches = useMediaQuery('(max-width: 1025px)');

  return (
    <>
      {props.type === 'title' && <div style={{ margin: '1.2rem 0' }}></div>}
      {props.type === 'option' && (
        <div style={{ margin: matches ? '.2rem 0' : '1rem' }}></div>
      )}
    </>
  );
}

export default Divider;
